import {
  useBuscarTops10ItemsIngresoDashboard,
  useBuscarTops10OfertasVendidasDashboard,
  useBuscarTops10VendedoresPorComision,
  useBuscarTops10ItemsVendidos,
} from "../../Scripts/Services/facturacion-service.js";

import { Dropdown, MultiSelect, ProgressSpinner, Message } from "primereact";
import React, { useEffect, useState } from "react";
const Top10 = ({ Top10, Tipo, ColorPrimario, MonedaPredeterminada }) => {
  const formatearValores = React.useMemo(() => {
    return (monto) => {
      return Citrus.Convert.toCurrencyNoSimbolo(monto);
    };
  }, []);
  return (
    <>
      {Object.keys(Top10).map((key) => {
        const item = Top10[key];
        const titulo = Object.keys(item)[Object.keys(item).length - 1];
        const cellTitutlo = titulo.split(" ");
        return (
          <div className="wrapper" id={titulo} key={titulo}>
            <div className="table">
              <div
                className="row_table"
                style={{
                  borderRadius: ".25rem .25rem 0 0",
                  display: "table-caption",
                  fontWeight: "900",
                  color: "#ffffff",
                  background: ColorPrimario,
                  textAlign: "center",
                  padding: "5px",
                  fontSize: "18px",
                }}
              >
                {titulo}
              </div>
              <div className="row_table header">
                <div className="cell">
                  <span>#</span>
                </div>
                <div className="cell" style={{ width: "400px" }}>
                  {cellTitutlo[0]}
                </div>
                <div
                  className="cell"
                  style={{ width: "300px", textAlign: "right" }}
                >
                  {Tipo !== "Cantidad"
                    ? `${Tipo} (${MonedaPredeterminada})`
                    : `${Tipo}`}
                </div>
              </div>
              {Object.keys(item).length < 2 ? (
                <div className="row_table">
                  <div style={{ rowSpan: "3" }} className="cell">
                    No hay datos disponibles
                  </div>
                </div>
              ) : (
                Object.keys(item).map((innerKey, index) => {
                  if (innerKey !== titulo) {
                    return (
                      <div className="row_table" key={index}>
                        <div className="cell" data-title="Posicion">
                          {index + 1}
                        </div>
                        <div
                          className="cell"
                          data-title="Cliente"
                          style={{ width: "400px" }}
                        >
                          {innerKey}
                        </div>
                        <div
                          className="tipo cell"
                          data-title={`${Tipo}`}
                          style={{ width: "300px", textAlign: "right" }}
                        >
                          {Tipo !== "Cantidad"
                            ? formatearValores(item[innerKey])
                            : item[innerKey]}
                        </div>
                      </div>
                    );
                  }
                  return null;
                })
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};
export const Top10Facturacion = () => {
  const moneda = window.monedaPredeterminada;
  const color = window.colorPrimario;
  const [tipo, setTipo] = React.useState(1);
  const [tipoDesc, setTipoDesc] = React.useState("Monto");
  const [periodo, setPeriodo] = React.useState("mensual");
  const tipos = [
    { name: "Monto", value: 1 },
    { name: "Cantidad", value: 2 },
  ];
  const [documento, setDocumento] = React.useState(null);
  const documentos = [
    { name: "Items Vendidos", value: 1 },
    { name: "Vendedores por Comision", value: 2 },
    { name: "Ofertas Vendidas", value: 3 },
    { name: "Ingresos por Items", value: 4 },
  ];

  const OpcionesPeriodo = [
    { label: "Todos", value: "-1" },
    { label: "Hoy", value: "diario" },
    { label: "Esta semana", value: "semanal" },
    { label: "Este mes", value: "mensual" },
    { label: "Este trimestre", value: "trimestral" },
    { label: "Este año", value: "anual" },
    { label: "Año anterior", value: "anual_anterior" },
  ];

  const [whereItemsVendidos, setWhereItemsVendidos] = React.useState(null);
  const [whereItemsIngresos, setWhereItemsIngresos] = React.useState(null);
  const [whereVendedoreComision, setWhereVendedoreComision] =
    React.useState(null);
  const [whereOfertasVendidas, setWhereOfertasVendidas] = React.useState(null);

  const {
    data: dataItemsVendidos,
    loading: cargandoItemsVendidos,
    error: errorItemsVendidos,
  } = useBuscarTops10ItemsVendidos(whereItemsVendidos);
  const {
    data: dataItemsIngreso,
    loading: cargandoItemsIngreso,
    error: errorItemsIngreso,
  } = useBuscarTops10ItemsIngresoDashboard(whereItemsIngresos);
  const {
    data: dataVendedoresComision,
    loading: cargandoVenderesComision,
    error: errorVendedoresComision,
  } = useBuscarTops10VendedoresPorComision(whereVendedoreComision);
  const {
    data: dataOfertasVendidas,
    loading: cargandoOfertasVendidas,
    error: errorOfertasVendias,
  } = useBuscarTops10OfertasVendidasDashboard(whereOfertasVendidas);

  const [mostrarItemsVendidos, setMostrarItemsVendidos] = React.useState(false);
  const [mostrarItemsIngresos, setMostrarItemsIngresos] = React.useState(false);
  const [mostrarVendedoresComision, setMostrarVendedoresComision] =
    React.useState(false);
  const [mostrarOfertasVendidas, setMostrarOfertasVendidas] =
    React.useState(false);

  function handleTipoCambio(value) {
    setTipo(value);
    var tipo;
    if (value == 1) tipo = "Monto";
    else if (value == 2) tipo = "Cantidad";
    setTipoDesc(tipo);
  }
  const handleChangePeriodo = (e) => {
    setPeriodo(e);
    if (mostrarItemsVendidos === true) {
      setWhereItemsVendidos({ where: { periodo: tipoDesc, periodoFecha: e } });
    }
    if (mostrarVendedoresComision === true) {
      setWhereVendedoreComision({
        where: { periodo: tipoDesc, periodoFecha: e },
      });
    }
    if (mostrarOfertasVendidas === true) {
      setWhereOfertasVendidas({
        where: { periodo: tipoDesc, periodoFecha: e },
      });
    }
    if (mostrarItemsIngresos === true) {
      setWhereItemsIngresos({ where: { periodo: tipoDesc, periodoFecha: e } });
    }
  };

  function handleDocumentoCambio(value) {
    setDocumento(value);
    if (value.includes(1)) {
      if (mostrarItemsVendidos === false) {
        setWhereItemsVendidos({
          where: { periodo: tipoDesc, periodoFecha: periodo },
        });
        setMostrarItemsVendidos(true);
      }
    } else {
      setMostrarItemsVendidos(false);
    }
    if (value.includes(2)) {
      if (mostrarVendedoresComision === false) {
        setWhereVendedoreComision({
          where: { periodo: tipoDesc, periodoFecha: periodo },
        });
        setMostrarVendedoresComision(true);
      }
    } else {
      setMostrarVendedoresComision(false);
    }
    if (value.includes(3)) {
      if (mostrarOfertasVendidas === false) {
        setWhereOfertasVendidas({
          where: { periodo: tipoDesc, periodoFecha: periodo },
        });
        setMostrarOfertasVendidas(true);
      }
    } else {
      setMostrarOfertasVendidas(false);
    }
    if (value.includes(4)) {
      if (mostrarItemsIngresos === false) {
        setWhereItemsIngresos({
          where: { periodo: tipoDesc, periodoFecha: periodo },
        });
        setMostrarItemsIngresos(true);
      }
    } else {
      setMostrarItemsIngresos(false);
    }
  }

  return (
    <React.Fragment>
      <div>
        <div style={{ display: "flex", marginTop: "30px" }}>
          <div
            className="card flex justify-content-center"
            style={{ marginRight: "5px" }}
          >
            <span className="p-float-label">
              <Dropdown
                inputId="dd-periodo"
                value={periodo}
                onChange={(e) => handleChangePeriodo(e.value)}
                options={OpcionesPeriodo}
                optionLabel="label"
                style={{ minWidth: "150px" }}
              />
              <label htmlFor="dd-periodo">Periodo</label>
            </span>
          </div>

          <div
            className="card flex justify-content-center"
            style={{ marginRight: "5px" }}
          >
            <span className="p-float-label">
              <Dropdown
                inputId="dd-city"
                value={tipo}
                onChange={(e) => handleTipoCambio(e.value)}
                options={tipos}
                optionLabel="name"
              />
              <label htmlFor="dd-city">Tipo</label>
            </span>
          </div>
          <div
            className="card flex justify-content-center"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span className="p-float-label" style={{ minWidth: "150px" }}>
              <MultiSelect
                value={documento}
                onChange={(e) => handleDocumentoCambio(e.value)}
                options={documentos}
                optionLabel="name"
                display="chip"
                Activos
                Fijos
                Banco
                Caja
                Chica
                selectAllLabel="Seleccionar todos"
              />
              <label htmlFor="ms-cities">Tipos Documento</label>
            </span>
          </div>
        </div>
        <>
          <div className="card_row" style={{ marginTop: "50px" }}>
            {[
              {
                data: dataItemsVendidos,
                mostrar: mostrarItemsVendidos,
                cargando: cargandoItemsVendidos,
              },
              {
                data: dataVendedoresComision,
                mostrar: mostrarVendedoresComision,
                cargando: cargandoVenderesComision,
              },
              {
                data: dataItemsIngreso,
                mostrar: mostrarItemsIngresos,
                cargando: cargandoItemsIngreso,
              },
              {
                data: dataOfertasVendidas,
                mostrar: mostrarOfertasVendidas,
                cargando: cargandoOfertasVendidas,
              },
            ].map(({ data, mostrar, cargando }, index) => (
              <React.Fragment key={index}>
                {cargando && mostrar ? (
                  <div
                    style={{
                      width: "50%",
                      height: "380px",
                      marginTop: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ProgressSpinner />
                  </div>
                ) : (
                  data != null &&
                  mostrar && (
                    <div style={{ width: "50%" }}>
                      <Top10
                        Top10={data.Top10}
                        Tipo={tipoDesc}
                        MonedaPredeterminada={moneda}
                        ColorPrimario={color}
                      />
                    </div>
                  )
                )}
              </React.Fragment>
            ))}
          </div>
        </>
      </div>
    </React.Fragment>
  );
};
